import Form, { formCreate } from '@/found/components/form';
import ProductRespVos from './product_list.vue';
import GiftRespVos from './gift_list.vue';
import PhotoRespVos from './photo_list.vue';

formCreate.component('ProductRespVos', ProductRespVos);
formCreate.component('GiftRespVos', GiftRespVos);
formCreate.component('PhotoRespVos', PhotoRespVos);

export default {
  name: 'table-component',
  extends: Form,
  data() {
    return {
      formFunctionCode: 'meeting_affair_charge_report_form',
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        const tempData = this.formConfig.row;
        this.setValue(tempData);
        if (tempData && tempData.productRespVos && tempData.productRespVos.length !== 0) { // 判断是否隐藏
          this.hiddenFields(false, ['productRespVos', 'title1']);
        } else {
          this.hiddenFields(true, ['productRespVos', 'title1']);
        }

        if (tempData && tempData.giftRespVos && tempData.giftRespVos.length !== 0) { // 判断是否隐藏
          this.hiddenFields(false, ['giftRespVos', 'title2']);
        } else {
          this.hiddenFields(true, ['giftRespVos', 'title2']);
        }

        if (tempData && tempData.photoRespVos && tempData.photoRespVos.length !== 0) { // 判断是否隐藏
          this.hiddenFields(false, ['photoRespVos', 'title3']);
        } else {
          this.hiddenFields(true, ['photoRespVos', 'title3']);
        }
      }
    },
    setRule(item) {
      const v = item;
      if (v.field === 'productRespVos') {
        v.props.value = this.formConfig.row.productRespVos || [];
      }
      if (v.field === 'giftRespVos') {
        v.props.value = this.formConfig.row.giftRespVos || [];
      }
      if (v.field === 'photoRespVos') {
        v.props.value = this.formConfig.row.photoRespVos || [];
      }
      return v;
    },
  },

};
